import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import RankingSection from './components/RankingSection';
import CategoryNav from './components/CategoryNav';
import FAQSection from './components/FAQSection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '布丁漫画',
      url: 'https://budingmanhua.com',
      description: '布丁漫画韩漫专区，精选热门韩漫推荐与排行，提供免费全集韩漫资源',
      sameAs: ['https://budingmanhua.com'],
    },
    {
      '@type': 'WebSite',
      name: '布丁漫画',
      url: 'https://budingmanhua.com',
      description: '布丁漫画 - 韩漫推荐与排行 | 免费全集下拉式阅读',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '布丁漫画 - 韩漫推荐与排行 | 免费全集下拉式阅读',
      description: '布丁漫画韩漫专区，精选热门韩漫推荐与排行，提供免费全集韩漫资源，支持下拉式在线观看，韩系画风剧情一次看个够。',
      url: 'https://budingmanhua.com',
      isPartOf: { '@id': 'https://budingmanhua.com/#website' },
      primaryImageOfPage: { '@id': 'https://budingmanhua.com/#primaryimage' },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://budingmanhua.com',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '布丁漫画的韩漫资源是免费的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，布丁漫画提供的所有韩漫资源均为免费阅读。我们致力于为广大韩漫爱好者提供优质的免费韩漫阅读体验，无需付费即可畅享热门韩漫全集。',
          },
        },
        {
          '@type': 'Question',
          name: '什么是下拉式阅读模式？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '下拉式阅读是布丁漫画专为移动端和网页端优化的阅读模式。用户只需向下滑动页面即可连续阅读，无需翻页操作，让韩漫阅读更加流畅自然。',
          },
        },
        {
          '@type': 'Question',
          name: '布丁漫画的韩漫推荐是如何筛选的？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的韩漫推荐基于综合评分系统，考量因素包括读者评分、阅读量、更新频率、作品质量等多个维度。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫更新频率是怎样的？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '布丁漫画紧跟各大韩漫平台的更新节奏，热门连载韩漫通常每周更新一话。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <RankingSection />
        <CategoryNav />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}